import { style } from "@vanilla-extract/css";
import { breakpoints } from "../../../styles/breakpoints";

export const addPlayer = style({
  width: 16,
  height: 16,
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: { width: 34, height: 34 },
  },
});
